import { useQueries, useQueryClient } from "@tanstack/react-query";

import { getFarmFootprintByYear, getFarmFootprintByYearAdmin } from "services";

import { getEnvironment, getLocalKlimVar, useGetCarbonProgramByFarmId, useUserContext } from "utils";

import { FOOTPRINTING_FARM } from "consts";

export const useGetFootprintingFarmFootprints = (farmId?: string, years: number[] = [], { enabled = true } = {}) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  const { user } = useUserContext();
  const { data: carbonProgram } = useGetCarbonProgramByFarmId(farmId);
  const token = getLocalKlimVar("token");

  // User context hook returns `null` on admin for whatever reason
  const isLoggedIn = isAdmin ? !!token : !!user && !!token;

  return useQueries({
    queries: years.map((year) => ({
      queryKey: [FOOTPRINTING_FARM, farmId, year, isAdmin],
      queryFn: () => (isAdmin ? getFarmFootprintByYearAdmin(farmId ?? "", year) : getFarmFootprintByYear(year)),
      enabled: enabled && carbonProgram?.platformFeatures?.footprinting?.enabled && !!farmId && !!year && isLoggedIn,
      queryClient,
      gcTime: 60000,
    })),
  });
};
